import { render, staticRenderFns } from "./UserReservations.vue?vue&type=template&id=79e79d66"
import script from "./UserReservations.vue?vue&type=script&lang=js"
export * from "./UserReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports